module.exports = __webpack_public_path__ + "static/media/HCMM575.aa42fe44.jpg";